import { Menu } from 'antd'
import Button from 'components/Button'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import MultiFilter from 'components/UIComponents/MultiFilter'
import { addDays } from 'date-fns'
import moment from 'moment'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import ErrorMessage from 'utils/ErrorMessage'
import TableSearchFilter from '../../components/UIComponents/TableSearchFilter'
import CsvImage from '../../components/icons/csv-image.svg'
import GoogleSheetImage from '../../components/icons/google-sheet.svg'
import XlsxImage from '../../components/icons/xlsx-image.svg'
import PageHeader from '../../modules/JobRoles/PageHeader/index'
import Debounce from '../../utils/Debounce'
import CustomDateRange from './CustomDateRange'
import Table from './PageHeader/DemoData/TableData'
import CTCRangeFilter from './PageHeader/JobRoleFilter/Partials/CTCRangeFilter'
import EvaluvactionScheduleFilter from './PageHeader/JobRoleFilter/Partials/EvaluvactionScheduleFilter'
import Role from './PageHeader/JobRoleFilter/Partials/Role'
import ApprovedModelIcon from '../../components/icons/TPORequestsIcons/PopupIcon/ApprovedModelIcon'
import { useNavigate } from 'react-router-dom'
import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from './PageHeader/JobRoleFilter/style'
import {
  BoldText,
  CustomSpin,
  CustomizeMenu,
  HeaderFullWidth,
  MultiPadding,
  SectionWrapper,
} from './PageHeader/style'
import CloseRoleDrawer from '../../components/UIComponents/CloseRolePopup'
import { useSelector } from 'react-redux'
let selectAllStructure = [
  {
    title: 'Select All',
    value: 'all',
    children: [],
  },
]

const JobRoles = ({
  getJobRoleList,
  addNewRound,
  roundData,
  updateNewRound,
  updateRoundData,
  instituteCampusId,
  exportCandidate,
  getExportFiledData,
  getCorporateData,
  getDepartmentList,
  getDegreeList,
  getDomainList,
  getStatusFilter,
  getRoleFilter,
  getScheduleFilter,
  getYear,
  getInstituteData,
  exportCSV,
  getJobCategory,
  duplicateRole,
  archiveJobRole,
  unarchiveJobRole,
}) => {
  const object = useRef()
  const navigate = useNavigate()
  const [jobRolesData, setJobRoleData] = useState({})
  const [jobCategories, setJobCategories] = useState([])
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [pageNum, setPageNum] = useState(0)
  const [searchValue, setSearchValue] = useState(null)
  const [sortBy, setSortBy] = useState('')
  const [loading, setLoading] = useState(true)
  const [roleFormFilterData, setRoleFormFilterData] = useState({})
  const [roleFormFilterValue, setRoleFormFilterValue] = useState([])
  const [multiSelect, setMultiSelect] = useState([])
  const [roleStatusData, setRoleStatusData] = useState({})
  const [roleStatusValue, setRoleStatusValue] = useState([])
  const [scheduleStatus, setScheduleStatus] = useState([])
  const [scheduleData, setScheduleData] = useState([])
  const [scheduleValue, setScheduleValue] = useState([])
  const [isDuplicated, setIsDuplicated] = useState(false)
  const [quickActivebtn, setQuickActivebtn] = useState('')
  const [fromSearch, setFromSearch] = useState('')
  const [toSearch, setToSearch] = useState('')
  const [isDateRange, setDateRange] = useState(false)
  const [filterCheck, setFilterCheck] = useState(false)
  const [yearData, setYearData] = useState([])
  const [yearValueState, setYearValueState] = useState({
    year: '',
    endedOn: '',
  })
  const instituteDetails = useSelector(
    state => state?.auth?.instituteDetails
  )
  const accessLevel = instituteDetails?.instituteSubscription?.accessLevel

  const [dateState, setDateState] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: 'selection',
    },
  ])

  const [isCustomRange, setIsCustomRange] = useState(false)
  const [exportOpen, setExportOpen] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)
  const [cancelState, setCancelState] = useState({})
  const [showEntendRolePopup, setShowEntendRolePopup] = useState(false)
  const [currentRole, setCurrentRole] = useState({})
  const handleEditRole = data => {
    if (data?.editCount >= 1) {
      setShowEntendRolePopup(true)
      setCurrentRole(data)
    }
  }
  const handleCloseClick = () => {
    setShowEntendRolePopup(false)
  }
  const handleApproveClick = data => {
    setShowEntendRolePopup(false)
    navigate(`editRole/${data?.id}`)
  }
  const handleCustomDateClick = () => {
    setIsCustomRange(true)
  }

  const handleDateRange = () => {
    setDateRange(true)
  }
  const handlePayload = () => {
    const getroleData =
      roleFormFilterValue.length !== 0 &&
      roleFormFilterValue
        .map(item => {
          return item.value
        })
        .join(',')

    const getStatus =
      roleStatusValue.length !== 0 &&
      roleStatusValue
        .map(item => {
          return item.value
        })
        .join(',')
    const getSchedule =
      scheduleValue.length !== 0 &&
      scheduleValue
        .map(item => {
          return item.value
        })
        .join(',')
    const getActive = quickActivebtn.length !== 0 && quickActivebtn[0]
    const scheduleStatusType =
      scheduleStatus.length !== 0 && scheduleStatus[0].value

    const getrole =
      roleFormFilterValue.length !== 0 &&
      getroleData
        ?.split(',')
        ?.filter(
          item => item !== 'External Application link (PIL or Direct Corporate)'
        )
        .join(',')

    const external =
      roleFormFilterValue.length !== 0 &&
      getroleData
        ?.split(',')
        ?.filter(
          item => item === 'External Application link (PIL or Direct Corporate)'
        )
        .join(',')
    let payload = {
      getrole,
      getStatus,
      getSchedule,
      getActive,
      fromSearch:
        fromSearch !== '' ? fromSearch : getActive ? getActive.min : '',
      toSearch: toSearch !== '' ? toSearch : getActive ? getActive.max : '',
      scheduleStatusType,
      external,
    }

    if (isDateRange) {
      payload.startDate = moment(dateState[0]?.startDate).format('YYYY-MM-DD')
      payload.endDate = moment(dateState[0]?.endDate).format('YYYY-MM-DD')
      setDateRange(false)
    }

    return payload
  }

  const fetchJobRoles = async ({
    pageNum = pageNum,
    searchValue = searchValue,
    sortBy = sortBy,
    domainId = apiState?.domainId,
    degreeId = apiState?.degreeId,
    degreeType = apiState?.degreeType,
    departmentId = apiState?.departmentId,
    yearValue = yearValueState?.year,
    jobCategory = state.selectedCategory,
  }) => {
    setLoading(true)
    const payload = handlePayload()
    try {
      setJobRoleData({})
      const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
      // Remove the duplicaate value in degreeType
      let uniqueDegreeTypeArray = [...new Set(degreeType.split(','))]
      let uniqueDegreeTypeString = uniqueDegreeTypeArray.join(',')

      const isArchiveTab = jobCategory === 'ARCHIVED'

      let data = {
        ...(searchValue ? { search: searchValue?.trim() } : {}),
        ...(sortBy?.order ? { order } : {}),
        ...(sortBy?.columnKey ? { sort: sortBy?.columnKey } : {}),
        ...(degreeType ? { degreeType: uniqueDegreeTypeString } : {}),
        ...(domainId ? { domainId: domainId } : {}),
        ...(degreeId ? { degreeId: degreeId } : {}),
        ...(departmentId ? { streamId: departmentId } : {}),
        ...(isArchiveTab ? { archived: 'true' } : {}),
        ...(jobCategory && !isArchiveTab ? { jobCategory: jobCategory } : {}),
        ...(payload?.scheduleStatusType !== false && payload !== undefined
          ? { evaluationType: payload?.scheduleStatusType }
          : {}),
        ...(payload?.endDate ? { endDate: payload?.endDate } : {}),
        ...(payload?.startDate ? { startDate: payload?.startDate } : {}),
        ...(payload?.getrole !== '' &&
        payload?.getrole != false &&
        payload !== undefined
          ? { rolePublishedBy: payload.getrole }
          : {}),
        ...(payload?.external !== '' &&
        payload?.external != false &&
        payload !== undefined
          ? { externalLink: true }
          : {}),
        ...(payload?.getStatus !== false && payload !== undefined
          ? { status: payload.getStatus }
          : {}),
        ...(payload?.getSchedule !== false && payload !== undefined
          ? { roundType: payload.getSchedule }
          : {}),
        ...(payload?.fromSearch !== '' && payload !== undefined
          ? { minCTC: payload.fromSearch * 100000 }
          : {}),
        ...(payload?.toSearch !== '' && payload !== undefined
          ? { maxCTC: payload.toSearch * 100000 }
          : {}),
        ...(yearValue !== '' && yearValue !== undefined
          ? { yearOfPassing: yearValue }
          : {}),
        ...(yearValue !== '' && yearValue !== undefined
          ? { batch: yearValue }
          : {}),
        pageLImit: 10,
        pageNo: pageNum,
      }

      if (state?.selectedCourses && state?.selectedCourses?.length > 0) {
        const selectedCourses = state?.selectedCourses?.flatMap(item => {
          if (item?.degree?.length > 0) {
            return item.degree.flatMap(degreeItem => {
              if (degreeItem?.department?.length > 0) {
                return degreeItem.department.map(departItem => ({
                  domainId: item.domainValue,
                  degreeId: degreeItem?.degreeValue,
                  streamId: departItem?.departmentValue,
                }))
              } else {
                return {
                  domainId: item.domainValue,
                  degreeId: degreeItem?.degreeValue,
                }
              }
            })
          } else {
            return {
              domainId: item.domainValue,
            }
          }
        })
        data.courses = selectedCourses
      }
      const rolesList = await getJobRoleList({
        instituteCampusId,
        data,
      })
      if (rolesList?.filters?.yearOfPassing) {
        setYearData(rolesList?.filters?.yearOfPassing || [])
      }
      setJobRoleData(rolesList)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const category = async () => {
    const result = await getJobCategory()
    const orderedCategories = [
      'PLACEMENT',
      'INTERNSHIP',
      'INTERNSHIP_PPO',
      'GIGS',
      'APPRENTICESHIP',
    ].filter(category => result?.data?.includes(category))
    setJobCategories(orderedCategories)
    setState({
      ...state,
      selectedCategory: orderedCategories[0],
    })
    fetchJobRoles({
      pageNum,
      searchValue,
      sortBy,
      jobCategory: orderedCategories[0],
    })
    fetchDomainList('', orderedCategories[0])
    getFilterCall({ jobCategory: orderedCategories[0] })
  }

  useEffect(() => {
    category()
  }, [])

  const CaptilizeLetter = text => {
    const words = text.toLowerCase().split('_')
    const camelCase = words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
    return camelCase
  }

  const getFilterCall = async ({ jobCategory = state.selectedCategory }) => {
    try {
      const getStatus = await getStatusFilter(instituteCampusId, jobCategory)
      setRoleStatusData(
        getStatus?.map(item => {
          return {
            label: CaptilizeLetter(item.roleStatus),
            value: item.roleStatus,
            nameValue: `Status - ${CaptilizeLetter(item.roleStatus)}`,
            role: 'status',
          }
        })
      )
      const getRole = await getRoleFilter(instituteCampusId, jobCategory)
      setRoleFormFilterData(
        getRole?.map(item => {
          return {
            name: item.Role,
            label: CaptilizeLetter(item.Role),
            value:
              item.Role?.toLowerCase() == 'pil'
                ? 'CORPORATE'
                : item.Role?.toLowerCase() == 'direct corporate'
                ? 'INSTITUTE'
                : item.Role,
            nameValue: `Role - ${item.Role}`,
            role: 'Role-form',
          }
        })
      )

      const scheduleFilterLabel = scheduleLabel => {
        if (scheduleLabel == 'FACE_TO_FACE') {
          return 'INTERVIEW'
        } else if (scheduleLabel == 'GROUP') {
          return 'GROUP DISCUSSION'
        } else {
          return scheduleLabel
        }
      }

      const getSchedule = await getScheduleFilter(
        instituteCampusId,
        jobCategory
      )
      setScheduleData(
        getSchedule?.map(item => {
          return {
            label:
              item.EvaluationSchedule == 'CV_SCREENING'
                ? 'CV Screening'
                : CaptilizeLetter(scheduleFilterLabel(item.EvaluationSchedule)),
            value: item.EvaluationSchedule,
            nameValue:
              item.EvaluationSchedule == 'CV_SCREENING'
                ? 'CV Screening'
                : CaptilizeLetter(scheduleFilterLabel(item.EvaluationSchedule)),
            role: 'schedule',
          }
        })
      )
    } catch (error) {
      ErrorMessage('Error fetching roles, Try again .')
    }
  }

  const ScheduleStatus = [
    {
      label: 'Scheduled',
      value: 'SCHEDULED',
      role: 'status-schedule',
      nameValue: 'Schedule Status - Scheduled',
    },
    {
      label: 'Not Scheduled',
      value: 'NOT_SCHEDULED',
      role: 'status-schedule',
      nameValue: 'Schedule Status - Not Scheduled',
    },
  ]

  const QuickSelection = [
    {
      value: '<1 LPA',
      nameValue: 'CTC range - <1 LPA',
      role: 'ctc-range',
      min: '',
      max: 1,
    },
    {
      value: '1-4 LPA',
      nameValue: 'CTC range - 1-4 LPA',
      role: 'ctc-range',
      min: 1,
      max: 4,
    },
    {
      value: '4-9 LPA',
      nameValue: 'CTC range - 4-9 LPA',
      role: 'ctc-range',
      min: 4,
      max: 9,
    },
    {
      value: '9-19 LPA',
      nameValue: 'CTC range - 9-19 LPA',
      role: 'ctc-range',
      min: 9,
      max: 19,
    },
    {
      value: '>20 LPA',
      nameValue: 'CTC range - >20 LPA',
      role: 'ctc-range',
      min: 20,
      max: '',
    },
  ]

  useEffect(() => {
    if (filterCheck) {
      const formatFrom = parseInt(fromSearch, 10).toLocaleString('en-IN')
      const formatTo = parseInt(toSearch, 10).toLocaleString('en-IN')
      let checkCTC =
        fromSearch !== '' || toSearch !== ''
          ? [
              {
                nameValue: `CTC range  ${
                  fromSearch !== '' && toSearch !== ''
                    ? formatFrom + ' - ' + formatTo + ' LPA'
                    : fromSearch !== ''
                    ? '>= ' + formatFrom + ' LPA'
                    : toSearch !== ''
                    ? '<= ' + formatTo + ' LPA'
                    : ''
                }`,
                role: 'from-to',
              },
            ]
          : quickActivebtn

      const multiSelectArray = [
        ...roleFormFilterValue,
        ...roleStatusValue,
        ...scheduleValue,
        ...checkCTC,
        ...scheduleStatus,
      ]

      if (isDateRange) {
        const date = {
          role: 'date',
          date:
            moment(dateState[0]?.startDate).format('DD/MM/YYYY') +
            moment(dateState[0]?.endDate).format('DD/MM/YYYY'),
          nameValue: `Start Date - ${moment(dateState[0]?.startDate).format(
            'DD/MM/YYYY'
          )} ${'  '} End Date -${moment(dateState[0]?.endDate).format(
            'DD/MM/YYYY'
          )}`,
        }
        multiSelectArray.push(date)
      }
      setMultiSelect(multiSelectArray)
      setFilterCheck(false)
    }
  }, [
    roleFormFilterValue,
    roleStatusValue,
    scheduleValue,
    quickActivebtn,
    filterCheck,
    scheduleStatus,
  ])

  const handleRoleChange = e => {
    const selectedValue = e.target.value
    const alreadySelected = roleFormFilterValue.some(
      item => item.value === selectedValue
    )

    if (alreadySelected) {
      const role = roleFormFilterData.filter(
        option => !option.value === e.target.value
      )
      setRoleFormFilterValue(role)
    } else {
      const role = roleFormFilterData.filter(
        option => option.value === e.target.value
      )
      setRoleFormFilterValue(role)
    }
  }

  const handleMultiFilter = selectedValue => {
    setFilterCheck(true)
    const multi = multiSelect.filter(
      item => !selectedValue.includes(item.nameValue)
    )
    const role = multi[0].role
    if (role === 'Role-form') {
      const valueset = roleFormFilterValue.filter(
        item => !multi.some(getvalue => getvalue.value === item.value)
      )
      setRoleFormFilterValue(valueset)
    } else if (role === 'status') {
      const valueset = roleStatusValue.filter(
        item => !multi.some(getvalue => getvalue.value === item.value)
      )
      setRoleStatusValue(valueset)
    } else if (role === 'schedule') {
      const valueset = scheduleValue.filter(
        item => !multi.some(getvalue => getvalue.value === item.value)
      )
      setScheduleValue(valueset)
    } else if (role === 'ctc-range') {
      const valueset = quickActivebtn.filter(
        item => !multi.some(getvalue => getvalue.value === item.value)
      )
      setQuickActivebtn(valueset)
    } else if (role === 'from-to') {
      setFromSearch('')
      setToSearch('')
    } else if (role === 'status-schedule') {
      if (multi[0].value === 'SCHEDULED') {
        setScheduleValue([])
      }
      setScheduleStatus([])
    }
  }

  const handleStatusChange = checkedValues => {
    const status = checkedValues.map(formValue => {
      return roleStatusData.find(option => option.value === formValue)
    })
    setRoleStatusValue(status)
  }

  const handleChangeSchedule = e => {
    const selectedValue = e.target.value
    const alreadySelected = scheduleStatus.some(
      status => status.value === selectedValue
    )
    if (selectedValue === 'NOT_SCHEDULED') {
      setScheduleValue([])
    }
    if (alreadySelected) {
      const updatedStatus = scheduleStatus.filter(
        status => status.value !== selectedValue
      )
      setScheduleStatus(updatedStatus)
    } else {
      const valueSet = ScheduleStatus.filter(
        item => item.value === selectedValue
      )
      setScheduleStatus(valueSet)
    }
  }

  const handleScheduleChange = checkedValues => {
    const schedule = checkedValues.map(formValue => {
      return scheduleData.find(option => option.value === formValue)
    })
    setScheduleValue(schedule)
  }

  const handleQuickButtonClick = item => {
    const getvalue = quickActivebtn.length !== 0 && quickActivebtn[0].value

    if (item.includes(getvalue)) {
      setQuickActivebtn([])
    } else {
      const role = item?.map(formValue => {
        return QuickSelection.find(option => option.value === formValue)
      })
      setQuickActivebtn(role)
    }
  }

  const handleFromSearch = value => {
    if (value < 5000000000) {
      setFromSearch(value)
      setQuickActivebtn([])
    }
  }

  const handleToSearch = value => {
    if (value < 5000000000) {
      setToSearch(value)
      setQuickActivebtn([])
    }
  }

  const handleFilterCancel = () => {
    setIsMenuOpen(false)
    setDateRange(false)

    setRoleFormFilterValue(cancelState?.roleForm ?? [])
    setRoleStatusValue(cancelState?.roleStatus ?? [])
    setScheduleValue(cancelState?.roleSchedule ?? [])
    setQuickActivebtn(cancelState?.activeButton ?? '')
    setDateState(
      cancelState?.dateState ?? [
        {
          startDate: new Date(),
          endDate: addDays(new Date(), 7),
          key: 'selection',
        },
      ]
    )
    setFromSearch(cancelState?.setFromSearch ?? '')
    setToSearch(cancelState?.setToSearch ?? '')
    setScheduleStatus(cancelState?.scheduleStatus ?? [])
    setIsCustomRange(cancelState?.isCustomRange ?? false)
  }

  const handleApplyFilter = () => {
    setCancelState({
      roleForm: roleFormFilterValue,
      roleStatus: roleStatusValue,
      roleSchedule: scheduleValue,
      activeButton: quickActivebtn,
      date: dateState,
      fromSearch: fromSearch,
      toSearch: toSearch,
      scheduleStatus: scheduleStatus,
      isCustomRange: isCustomRange,
    })
    if (parseInt(fromSearch) > parseInt(toSearch)) {
      ErrorMessage(`From Value ${fromSearch} is more than To Value ${toSearch}`)
    } else {
      setFilterCheck(true)
      setIsMenuOpen(false)
    }
  }

  useEffect(() => {
    if (filterCheck) {
      setPageNum(0)
      fetchJobRoles({ pageNum: 0, searchValue, sortBy })
    }
  }, [filterCheck])

  const menu = (
    <MenuFlex
      column
      className="job-roles-filter"
      style={{ width: 'max-content' }}
    >
      {isDateRange ? (
        <CustomDateRange
          handleCustomDateClick={handleCustomDateClick}
          isCustomRange={isCustomRange}
          state={dateState}
          setState={setDateState}
        />
      ) : (
        <StyledTab
          width={'35%'}
          padding={'20px'}
          border={true}
          tabPosition={'left'}
          type="card"
          items={[
            {
              label: ' Role From',
              key: '1',
              children: (
                <Role
                  options={roleFormFilterData}
                  value={
                    roleFormFilterValue?.length !== 0 &&
                    roleFormFilterValue?.map(item => {
                      return item.value
                    })
                  }
                  onChange={handleRoleChange}
                  valueParam="value"
                  labelParam="label"
                />
              ),
            },
            {
              label: 'CTC Range',
              key: '2',
              children: (
                <CTCRangeFilter
                  handleFromSearch={handleFromSearch}
                  handleToSearch={handleToSearch}
                  fromSearch={fromSearch}
                  toSearch={toSearch}
                  handleQuickButtonClick={handleQuickButtonClick}
                  quickActivebtn={
                    quickActivebtn.length !== 0 &&
                    quickActivebtn?.map(item => {
                      return item.value
                    })
                  }
                  QuickSelection={QuickSelection}
                />
              ),
            },
            {
              label: 'Evaluation Schedule',
              key: '3',
              children: (
                <EvaluvactionScheduleFilter
                  handleChangeSchedule={handleChangeSchedule}
                  scheduleStatus={
                    scheduleStatus.length !== 0 && scheduleStatus[0]?.value
                  }
                  scheduleData={scheduleData}
                  handleScheduleChange={handleScheduleChange}
                  ScheduleStatus={ScheduleStatus}
                  scheduleValue={
                    scheduleValue.length !== 0 &&
                    scheduleValue.map(item => {
                      return item.value
                    })
                  }
                />
              ),
            },
            {
              label: 'Status',
              key: '4',
              children: (
                <FilterCheckBoxComp
                  options={roleStatusData}
                  value={
                    roleStatusValue.length !== 0 &&
                    roleStatusValue?.map(item => {
                      return item.value
                    })
                  }
                  onChange={handleStatusChange}
                  valueParam="value"
                  labelParam="label"
                />
              ),
            },
          ].filter(item => !item.hidden)}
        />
      )}
      <SubmitFlex right>
        {scheduleStatus.length !== 0 &&
          scheduleStatus[0].value === 'SCHEDULED' && (
            <Button.Secondary
              text="Select Date Range"
              onClick={handleDateRange}
            />
          )}
        <Button.Secondary text="Cancel" onClick={handleFilterCancel} />
        <Button.Primary text="Apply Filter" onClick={handleApplyFilter} />
      </SubmitFlex>
    </MenuFlex>
  )

  const ScrollRef = () => {
    object.current.scrollIntoView({ behavior: 'smooth' })
  }

  const handleExportClick = async selectedKeys => {
    try {
      let formatedKeys = selectedKeys?.map(item => item.title)
      let payload = {
        keys: formatedKeys,
      }
      await exportCandidate(payload)
    } catch (error) {
      //
    }
  }

  const handleYearChange = (e, option) => {
    if (option === undefined) {
      setYearValueState({ year: '' })
    } else setYearValueState(option?.option)
    fetchJobRoles({
      yearValue: option === undefined ? '' : option?.option?.year,
      pageNum: 0,
    })
  }

  const [stateList, setStateList] = useState({
    domainList: [],
    degreeList: [],
    departmentList: [],
  })

  const [state, setState] = useState({
    selectedDomain: [],
    selectedDegree: [],
    selectedDepartment: [],
    selectedCourses: [],
    selectedCategory: '',
  })

  const [apiState, setApiState] = useState({
    domainId: '',
    degreeId: '',
    degreeType: '',
    departmentId: '',
  })

  const fetchDepartmentList = useCallback(
    async (
      domain,
      degree,
      search = '',
      jobCategory = state?.selectedCategory
    ) => {
      try {
        let payLoad = {
          domainId: domain,
          degreeId: degree,
          jobCategory: jobCategory,
          search: search,
        }

        const response = await getDepartmentList(instituteCampusId, payLoad)
        if (response?.length) {
          const data = response.map(item => {
            let children = item.degree.map(data => {
              const departArr = data.degreeStreamMap.map(v => {
                return {
                  value: data.id + ' ' + v.stream.id + ' ' + item?.id,
                  title: v.stream.name,
                  degree: data.name,
                  degreeValue: data.id,
                  domain: item.name,
                  domainValue: item.id,
                  departmentValue: v.stream.id,
                  text: 'depart',
                  department: v.stream.name,
                }
              })
              return {
                value: data.id,
                title: data.name,
                domain: item.name,
                domainValue: item.id,
                children: departArr,
                text: 'degree',
              }
            })
            return {
              value: item.id,
              title: item.name,
              children: children,
              text: 'domain',
            }
          })
          const departmentData = selectAllStructure.map(item => {
            return {
              ...item,
              children: data,
            }
          })
          setStateList(prevState => ({
            ...prevState,
            departmentList: departmentData,
          }))
        } else {
          setStateList(prevState => ({
            ...prevState,
            departmentList: [],
          }))
        }
        return response
      } catch (err) {
        //
      }
    },
    []
  )


  const fetchDegreeList = useCallback(
    async ({ domain, search = '', jobCategory = state.selectedCategory }) => {
      try {
        const domainId = domain ? domain : apiState.domainId
        const response = await getDegreeList(
          domainId,
          instituteCampusId,
          jobCategory,
          search
        )
        if (response?.length) {
          const data = response.map(item => {
            let children = item.degree.map(data => {
              return {
                value: data.id,
                title: data.name,
                domain: item.name,
                domainValue: item.id,
                text: 'degree',
                type: data.type,
              }
            })
            return {
              value: item.id,
              title: item.name,
              children: children,
              text: 'domain',
            }
          })
          const degreeData = selectAllStructure.map(item => {
            return {
              ...item,
              children: data,
            }
          })

          setStateList(prevState => ({
            ...prevState,
            degreeList: degreeData,
          }))
          return data
        } else {
          setStateList(prevState => ({
            ...prevState,
            degreeList: [],
          }))
        }
      } catch (err) {
        //
      }
    },
    []
  )

  const fetchDomainList = useCallback(
    async (search = '', jobCategory = state?.selectedCategory) => {
      try {
        const response = await getDomainList(
          instituteCampusId,
          jobCategory,
          search
        )
        if (response?.length) {
          const structure = response.map(item => {
            return {
              title: item.name,
              value: item.id,
            }
          })
          const domainData = selectAllStructure.map(item => {
            return {
              ...item,
              children: structure,
            }
          })

          setStateList(prevState => ({
            ...prevState,
            domainList: domainData,
          }))
          return domainData
        } else {
          setStateList(prevState => ({
            ...prevState,
            domainList: [],
          }))
          return []
        }
      } catch (err) {
        //
      }
    },
    []
  )

  const handleDomainSearch = useCallback(
    Debounce(data => {
      fetchDomainList(data)
    }, 1000),
    []
  )

  const handleDegreeSearch = useCallback(
    Debounce(searchTerm => {
      if (apiState?.domainId) {
        fetchDegreeList({ domain: apiState?.domainId, search: searchTerm })
      }
    }, 1000),
    [apiState?.domainId, fetchDegreeList]
  )

  const handleDepartmentSearch = useCallback(
    Debounce(data => {
      if (apiState?.degreeId) {
        fetchDepartmentList(
          apiState?.domainId,
          apiState?.degreeId,
          data,
          state.selectedCategory
        )
      }
    }, 1000),
    [apiState?.degreeId, fetchDepartmentList]
  )


  const handleDomainChange = (value, label, extra) => {
    const selectedNodeProps = extra.triggerNode.props
    const idArr = value.map(item => item.value)
    const idJoin = idArr.join(',')
    setApiState(prevState => ({
      ...prevState,
      domainId: idJoin,
      degreeId: value.length === 0 ? '' : prevState?.degreeId,
      departmentId: value?.length === 0 ? '' : prevState?.departmentId,
      degreeType: value?.length === 0 ? '' : prevState?.degreeType,
    }))
    fetchDegreeList({ domain: idJoin, jobCategory: state?.selectedCategory })
    fetchJobRoles({
      pageNum: 0,
      searchValue,
      sortBy,
      domainId: idJoin,
      degreeId: value.length === 0 ? '' : apiState?.degreeId,
      departmentId: value?.length === 0 ? '' : apiState?.departmentId,
      degreeType: value?.length === 0 ? '' : apiState?.degreeType,
    })
    const selectedCourses = []

    const existedFilter = state?.selectedCourses?.some(
      item => item.domainValue === selectedNodeProps.value
    )
    if (selectedNodeProps?.value === 'all') {
      let b = selectedNodeProps?.children.map(item => {
        return {
          domain: item.props.title,
          domainValue: item.props.value,
        }
      })
      selectedCourses.push(...b)
    } else {
      if (existedFilter) {
        const filteredCourses = state?.selectedCourses.filter(
          item => item.domainValue !== selectedNodeProps.value
        )
        selectedCourses.push(...filteredCourses)
      } else {
        let selectedDomain = {
          domain: selectedNodeProps.title,
          domainValue: selectedNodeProps.value,
        }
        state.selectedCourses.push(selectedDomain)
        selectedCourses.push(...state.selectedCourses)
      }
    }

    // Remove degrees associated with removed domains
    const newSelectedDegree = state.selectedDegree.filter(degree => {
      return state.selectedCourses.some(course =>
        course.degree?.some(
          d => d.degreeValue === degree && idArr.includes(course.domainValue)
        )
      )
    })

    let updatedDepartment = [...state.selectedDepartment]
    updatedDepartment = state.selectedDepartment?.filter(item => {
      let parts = item?.split(' ')
      if (parts.length !== 3) {
        return false
      }
      let domainId = parts[2]
      if (selectedNodeProps?.value === domainId) {
        return false
      }
      return true
    })
    setState(prevState => ({
      ...prevState,
      selectedDomain: value,
      selectedDegree: value.length === 0 ? [] : newSelectedDegree, // Clear degrees if no domains left
      // selectedDegree: value.length === 0 ? [] : newSelectedDegree,
      selectedDepartment: value.length === 0 ? [] : updatedDepartment,
      selectedCourses: selectedCourses,
    }))
  }

  const handleDegreeChange = (value, label, extra) => {
    const selectedNodeProps = extra.triggerNode.props
    const idArr = state.selectedDomain.map(item => item.value)
    const idDomainJoin = idArr.join(',')
    const valueFilter = value.filter(item => item !== '')
    const idJoin = valueFilter.join(',')
    const getData = stateList.degreeList[0]?.children
      .map(item =>
        item?.children.map(type => {
          if (value.includes(type.value)) return type.type
        })
      )
      .flat()
      .filter(item => item !== undefined)
    setApiState(prevState => ({
      ...prevState,
      domainId: idDomainJoin,
      degreeType: getData?.join(','),
      degreeId: idJoin,
      departmentId: value?.length === 0 ? '' : prevState?.departmentId,
    }))
    fetchDepartmentList(idDomainJoin, idJoin, '', state.selectedCategory)
    fetchJobRoles({
      pageNum: 0,
      searchValue,
      sortBy,
      domainId: idDomainJoin,
      degreeType: getData?.join(','),
      degreeId: idJoin,
      departmentId: value?.length === 0 ? '' : apiState?.departmentId,
    })

    let selectedCourses = []

    const existedFilter =
      state.selectedDegree &&
      state.selectedCourses?.some(item =>
        state.selectedDegree?.includes(item?.degreeValue)
      )
    let updatedDepartment = [...(state?.selectedDepartment || [])]

    if (selectedNodeProps.value === 'all') {
      const all = selectedNodeProps.children.map(item => {
        const selectedDomainDegree = item.props.children.map(data => {
          return {
            domain: data.props.domain,
            domainValue: data.props.domainValue,
            degree: data.props.title,
            degreeValue: data.props.value,
          }
        })
        return selectedDomainDegree
      })
      const mergedArray = [].concat(...all)
      const removeAll = state.selectedCourses.map(item => {
        const v = mergedArray.filter(
          data => data.domainValue === item.domainValue
        )
        return {
          ...item,
          degree: v,
        }
      })
      selectedCourses = removeAll
    } else {
      if (existedFilter) {
        const filteredCourses = state.selectedCourses.filter(
          item => !state?.selectedDegree?.includes(item.degreeValue)
        )
        selectedCourses = filteredCourses
      } else {
        if (selectedNodeProps.text === 'degree') {
          let selectedCurrentObj = {
            domain: selectedNodeProps.domain,
            domainValue: selectedNodeProps.domainValue,
            degree: selectedNodeProps.title,
            degreeValue: selectedNodeProps.value,
          }

          const selectedArr = state.selectedCourses.map(item => {
            if (item.domainValue === selectedNodeProps.domainValue) {
              const existingObjRemove = Array.isArray(item.degree)
                ? item.degree
                : []
              const updatedDegree = existingObjRemove.filter(
                degreeItem => degreeItem.degreeValue !== selectedNodeProps.value
              )

              const isExist = existingObjRemove.some(
                degreeItem =>
                  degreeItem?.degreeValue === selectedNodeProps.value
              )
              if (isExist) {
                return {
                  ...item,
                  degree: updatedDegree,
                }
              } else {
                return {
                  ...item,
                  degree: [...existingObjRemove, selectedCurrentObj],
                }
              }
            } else {
              const degreeArr = item?.degree ? item.degree : []
              return {
                ...item,
                degree: [...degreeArr],
              }
            }
          })

          selectedCourses = selectedArr
        } else {
          const selectedChild = selectedNodeProps.children.map(data => {
            return {
              domain: data.props.domain,
              domainValue: data.props.domainValue,
              degree: data.props.title,
              degreeValue: data.props.value,
            }
          })
          const selectedArr = state.selectedCourses.map(item => {
            const degree =
              selectedNodeProps.value === item.domainValue
                ? selectedChild
                : item.degree
            return {
              ...item,
              degree: degree ? degree : [],
            }
          })

          selectedCourses = selectedArr
        }
      }
    }
    if (state?.selectedDegree?.length > value.length) {
      updatedDepartment = state.selectedDepartment?.filter(item => {
        let parts = item?.split(' ')
        if (parts.length !== 3) {
          return false
        }
        let domainId = parts[2]
        let degreeId = parts[0]

        if (
          selectedNodeProps?.value === domainId &&
          selectedNodeProps?.text == 'domain'
        ) {
          return false
        }
        if (
          selectedNodeProps?.value === degreeId &&
          selectedNodeProps?.text == 'degree'
        ) {
          return false
        }
        return true
      })
    }
    setState(prevState => ({
      ...prevState,
      selectedDegree: value,
      selectedCourses: selectedCourses,
      selectedDepartment: value.length === 0 ? [] : updatedDepartment,
    }))
  }

  const handleDepartmentChange = (value, label, extra) => {
    const selectedNodeProps = extra.triggerNode.props
    let selectedCourses = []
    if (selectedNodeProps.value === 'all') {
      const allChildren = selectedNodeProps.children.map(item => {
        const children = item.props.children.map(data => {
          const departChildren = data.props.children.map(depart => {
            return {
              ...depart.props,
            }
          })
          let degreeObj = {
            ...data.props,
            department: departChildren,
            degree: data.props.title,
            degreeValue: data.props.value,
          }
          return {
            ...degreeObj,
          }
        })
        let domainObj = {
          ...item.props,
          degree: children,
          domain: item.props.title,
          domainValue: item.props.value,
        }
        return {
          ...domainObj,
        }
      })
      const selected = state.selectedCourses.map(item => {
        const child = allChildren.find(
          data => data.domainValue === item.domainValue
        )
        if (child) {
          let degreeList
          if (child?.degree?.length === item?.degree?.length) {
            degreeList = item.degree.map((degreeItem, index) => {
              return {
                ...degreeItem,
                department: child.degree[index].department,
              }
            })
          } else {
            degreeList = item.degree.map(degreeItem => {
              return {
                ...degreeItem,
                department: [],
              }
            })
          }
          return {
            ...item,
            degree: degreeList,
          }
        } else {
          let removeDepartment = []
          if (allChildren.length === 0) {
            removeDepartment = item.degree.map(degree => {
              return {
                ...degree,
                department: [],
              }
            })
          }
          let uncheckAll = {
            ...item,
            degree: removeDepartment,
          }
          return allChildren.length === 0 ? uncheckAll : item
        }
      })
      selectedCourses = selected
    } else {
      if (selectedNodeProps.text === 'domain') {
        const degreeList = selectedNodeProps.children.map(item => {
          const departList = item.props.children
          const departmentList = departList.map(data => {
            return {
              ...data.props,
            }
          })
          return {
            ...item.props,
            degree: item.props.title,
            degreeValue: item.props.value,
            department: departmentList,
          }
        })
        const selectedDomainObj = {
          ...selectedNodeProps,
          domain: selectedNodeProps.title,
          domainValue: selectedNodeProps.value,
          degree: degreeList,
        }
        const selected = state.selectedCourses.map(item => {
          if (item.domainValue === selectedNodeProps.value) {
            let selectedDegree = []
            if (degreeList.length === 0) {
              selectedDegree = item.degree.map(degreeOb => {
                return {
                  ...degreeOb,
                  department: [],
                }
              })
            }
            let currentDegreeList = {
              ...selectedDomainObj,
              degree: selectedDegree,
            }
            return degreeList.length === 0
              ? currentDegreeList
              : selectedDomainObj
          } else {
            return item
          }
        })
        selectedCourses = selected
      } else if (selectedNodeProps.text === 'degree') {
        const degreeArray =
          selectedNodeProps.children.length > 0
            ? selectedNodeProps.children
            : []

        const departmentList = degreeArray.map(item => {
          return {
            ...item.props,
          }
        })
        const selected = state.selectedCourses.map(item => {
          if (item.domainValue === selectedNodeProps.domainValue) {
            if (item?.degree) {
              const findDegree = item.degree.find(
                data => data.degreeValue === selectedNodeProps.value
              )
              if (findDegree) {
                findDegree.department = departmentList || []
              }
            }
            return item
          } else {
            return item
          }
        })

        selectedCourses = selected
      } else {
        const selected = state.selectedCourses.map(item => {
          if (item.domainValue === selectedNodeProps.domainValue) {
            const findDegree = item.degree.map(data => {
              if (data.degreeValue === selectedNodeProps.degreeValue) {
                let departmentIdExists = false
                if (data?.department) {
                  departmentIdExists = data.department.some(
                    dep =>
                      dep.departmentValue === selectedNodeProps.departmentValue
                  )
                }

                const departmentObj = {
                  ...selectedNodeProps,
                }
                let department = []
                if (departmentIdExists) {
                  department = data.department.filter(
                    item =>
                      item.departmentValue !== selectedNodeProps.departmentValue
                  )
                } else {
                  department = data.department
                    ? [...data.department, departmentObj]
                    : [departmentObj]
                }
                return {
                  ...data,
                  department: department,
                }
              } else {
                return data
              }
            })
            return {
              ...item,
              degree: findDegree,
            }
          } else {
            return item
          }
        })
        selectedCourses = selected
      }
    }
    const idArr = state.selectedDomain.map(item => item.value)
    const idDomainJoin = idArr.join(',')
    const degreeIdArr = state.selectedDegree.map(item => item)
    const idDegreeJoin = degreeIdArr.join(',')

    const idSelectedArr = value
      .filter(item => item.includes(' ') && item.split(' ')[0])
      .map(item => {
        const id = item.split(' ')
        return id[1]
      })
    const idDepartmentArr = idSelectedArr.join(',')
    setApiState(prevState => ({
      ...prevState,
      domainId: idDomainJoin,
      degreeId: idDegreeJoin,
      departmentId: idDepartmentArr,
    }))
    fetchJobRoles({
      pageNum: 0,
      searchValue,
      sortBy,
      domainId: idDomainJoin,
      degreeId: idDegreeJoin,
      departmentId: idDepartmentArr,
    })
    console.log('handleDepartmentChange - selectedCourses:', selectedCourses);
    setState(prevState => ({
      ...prevState,
      selectedDepartment: value,
      selectedCourses: selectedCourses,
    }))
  }


  const handleRemoveFilter = data => {
    const domainIndex = data?.indices?.domainIndex
    const degreeIndex = data?.indices?.degreeIndex
    const departmentIndex = data?.indices?.departmentIndex
    let selectedCourses
    let removedDomain = [...state.selectedDomain]
    let removedDegree = [...state.selectedDegree]
    let removedDepartment = [...state.selectedDepartment]

    if (Object.keys(data?.indices).length === 1) {
      const selectedId = state.selectedCourses[domainIndex]
      selectedCourses = state.selectedCourses.filter(
        obj => obj.domainValue !== selectedId.domainValue
      )
      removedDomain = state.selectedDomain.filter(
        item => item.value !== selectedId.domainValue
      )
    } else if (Object.keys(data?.indices).length === 2) {
      const selectedId = state.selectedCourses[domainIndex]?.degree[degreeIndex]
      if (selectedId) {
        let selectedDegreeList = state?.selectedCourses[
          domainIndex
        ]?.degree?.filter(obj => obj.degreeValue !== selectedId.degreeValue)
        selectedCourses = state.selectedCourses.map(item => {
          if (
            item.domainValue === state.selectedCourses[domainIndex].domainValue
          ) {
            return {
              ...item,
              degree: selectedDegreeList,
            }
          } else {
            return item
          }
        })
      }
      removedDegree =
        state.selectedDegree?.length > 0 &&
        state.selectedDegree.filter(item => item !== selectedId.degreeValue)
    } else {
      const selectedId =
        state.selectedCourses[domainIndex]?.degree[degreeIndex]?.department[
          departmentIndex
        ]

      if (selectedId) {
        let selectedDepartmentList = state.selectedCourses[domainIndex].degree[
          degreeIndex
        ].department.filter(
          obj => obj.departmentValue !== selectedId.departmentValue
        )
        selectedCourses = state.selectedCourses.map(item => {
          if (item.domainValue === selectedId.domainValue) {
            const selectedDegree = item.degree.map(degree => {
              if (degree.degreeValue === selectedId.degreeValue) {
                return {
                  ...degree,
                  department: selectedDepartmentList,
                }
              } else {
                return degree
              }
            })
            return {
              ...item,
              degree: selectedDegree,
            }
          } else {
            return item
          }
        })
        removedDepartment = state?.selectedDepartment?.filter(
          item => item !== selectedId.value
        )
      }
    }
    const idArr = removedDomain.map(item => item.value)
    const idDomainJoin = idArr.join(',')
    const degreeIdArr = removedDegree.map(item => item)
    const idDegreeJoin = degreeIdArr.join(',')

    const getData = stateList.degreeList[0]?.children
      .map(item =>
        item?.children.map(type => {
          if (removedDegree.includes(type.value)) return type.type
        })
      )
      .flat()
      .filter(item => item !== undefined)
    const idSelectedArr = removedDepartment.map(item => {
      const id = item.split(' ')
      return id[1]
    })
    const idDepartmentArr = idSelectedArr.join(',')
    setApiState(prevState => ({
      ...prevState,
      domainId: idDomainJoin,
      degreeId: idDegreeJoin,
      degreeType: getData?.join(','),
      departmentId: idDepartmentArr,
    }))
    fetchJobRoles({
      pageNum,
      searchValue,
      sortBy,
      domainId: idDomainJoin,
      degreeId: idDegreeJoin,
      degreeType: getData?.join(','),
      departmentId: idDepartmentArr,
    })
    setState(prevState => ({
      ...prevState,
      selectedCourses: selectedCourses,
      selectedDomain: removedDomain,
      selectedDegree: removedDegree,
      selectedDepartment: removedDepartment,
    }))
  }

  const handleTabClick = data => {
    const isArchiveTab = data.value === 'ARCHIVED'
    setState(prev => ({
      ...prev,
      selectedCategory: data.value,
    }))
    setPageNum(0)
    fetchJobRoles({
      pageNum: 0,
      searchValue: searchValue,
      sortBy: sortBy,
      jobCategory: data.value,
    })
    // ARCHIVED is a pseudo-category — the domain/filter endpoints reject it as an
    // invalid jobCategory, so skip those side-effect calls on the Archive tab.
    if (!isArchiveTab) {
      fetchDomainList('', data.value)
      getFilterCall({ jobCategory: data.value })
    }
  }

  React.useEffect(() => {
    if (searchValue !== null) {
      const timeout = setTimeout(() => {
        setPageNum(0)
        fetchJobRoles({
          pageNum: 0,
          searchValue: searchValue,
          sortBy,
        })
      }, 1000)
      return () => {
        clearTimeout(timeout)
      }
    }
    if (isDuplicated) {
      const timeout = setTimeout(() => {
        setPageNum(0)
        fetchJobRoles({
          pageNum: 0,
        })
        setIsDuplicated(false)
      }, 1000)
      return () => {
        clearTimeout(timeout)
      }
    }
  }, [searchValue, isDuplicated])

  const handleCSVClick = async type => {
    setExportLoading(true)
    let payload = {
      domainId: apiState.domainId,
      degreeId: apiState.degreeId,
      streamId: apiState.departmentId,
      jobCategory: state.selectedCategory,
      yearOfPassing: yearValueState.year,
      degreeType: apiState?.degreeType,
    }
    if (type === 'xlsx') {
      try {
        const blob = await exportCSV(instituteCampusId, payload, type)
        const url = window.URL.createObjectURL(new Blob([blob]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `${CaptilizeLetter(state.selectedCategory)}_Roles.xlsx`
        )
        document.body.appendChild(link)
        link.click()
        link.parentNode.removeChild(link)
        setExportOpen(false)
        setExportLoading(false)
      } catch (error) {
        setExportLoading(false)
        ErrorMessage(error)
      }
    } else if (type === 'googlesheet') {
      try {
        const data = await exportCSV(instituteCampusId, payload, type)
        window.open(data.data.url, '_blank')
        setExportOpen(false)
        setExportLoading(false)
      } catch (error) {
        setExportLoading(false)
        ErrorMessage(error)
      }
    } else {
      try {
        const blob = await exportCSV(instituteCampusId, payload, type)
        const url = window.URL.createObjectURL(
          new Blob([blob], { type: 'text/csv' })
        )
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `${CaptilizeLetter(state.selectedCategory)}_Roles.csv`
        )

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setExportOpen(false)
        setExportLoading(false)
      } catch (error) {
        setExportLoading(false)
        ErrorMessage(error)
      }
    }
  }

  const menuItem = [
    {
      label: 'XLSX',
      type: 'xlsx',
      image: XlsxImage,
    },
    {
      label: 'Google Sheet',
      type: 'googlesheet',
      image: GoogleSheetImage,
    },
    {
      label: 'CSV',
      type: 'csv',
      image: CsvImage,
    },
  ]
  const exportMenu = (
    <CustomizeMenu>
      {exportLoading ? (
        <Menu.Item key="loading">
          <CustomSpin tip="Loading" size="medium" />
        </Menu.Item>
      ) : (
        <>
          {menuItem.map((item, index) => {
            return (
              <Menu.Item
                key={index + 'menuItem'}
                icon={<img src={item.image} />}
                onClick={() => handleCSVClick(item.type)}
              >
                {item.label}
              </Menu.Item>
            )
          })}
        </>
      )}
    </CustomizeMenu>
  )

  const handleExportOpen = () => {
    setExportLoading(false)
    setExportOpen(true)
  }

  return (
    <SectionWrapper>
      <div ref={object}></div>
      <HeaderFullWidth>
        <PageHeader
          jobCategories={jobCategories}
          handleExportClick={handleExportClick}
          getExportFiledData={getExportFiledData}
          yearData={yearData}
          handleYearChange={handleYearChange}
          yearValue={yearValueState?.year}
          state={state}
          handleDomainChange={handleDomainChange}
          handleDegreeChange={handleDegreeChange}
          handleDepartmentChange={handleDepartmentChange}
          stateList={stateList}
          handleRemoveFilter={handleRemoveFilter}
          handleTabClick={handleTabClick}
          handleDomainSearch={handleDomainSearch}
          handleDegreeSearch={handleDegreeSearch}
          handleDepartmentSearch={handleDepartmentSearch}
          exportMenu={exportMenu}
          exportOpen={exportOpen}
          exportLoading={exportLoading}
          setExportOpen={setExportOpen}
          handleExportOpen={handleExportOpen}
          accessLevel={accessLevel}
        />
        <TableSearchFilter
          placeholder="Search by keyword"
          setSearchValue={setSearchValue}
          searchValue={searchValue}
          menu={menu}
          open={isMenuOpen}
          setOpen={setIsMenuOpen}
          onOpenChange={() => setIsMenuOpen(!isMenuOpen)}
          currentCount={
            jobRolesData?.count < 10
              ? jobRolesData?.count
              : pageNum * 10 + jobRolesData?.result?.length
          }
          totalCount={jobRolesData?.count}
          minWidth={isDateRange ? 'auto' : ''}
          filterPosition={'end'}
          searchWidth={'60%'}
          filterWidth={'20%'}
        />

        {multiSelect.length !== 0 && (
          <MultiPadding>
            <BoldText>Filter</BoldText>
            <MultiFilter
              jobRoleForm={
                multiSelect.length !== 0 &&
                multiSelect?.map(item => {
                  return item.nameValue
                })
              }
              option={false}
              handleChange={handleMultiFilter}
            />
          </MultiPadding>
        )}
        <Table
          ScrollRef={ScrollRef}
          setPageNum={setPageNum}
          pageNum={pageNum}
          setSortBy={setSortBy}
          loading={loading}
          data={jobRolesData?.result || []}
          fetchJobRoles={fetchJobRoles}
          totalPages={jobRolesData?.count || 0}
          setLoading={setLoading}
          page={jobRolesData?.page || 0}
          addNewRound={addNewRound}
          roundData={roundData}
          updateNewRound={updateNewRound}
          updateRoundData={updateRoundData}
          getCorporateData={getCorporateData}
          getInstituteData={getInstituteData}
          instituteCampusId={instituteCampusId}
          sortBy={sortBy}
          searchValue={searchValue}
          duplicateRole={duplicateRole}
          setIsDuplicated={setIsDuplicated}
          isDuplicated={isDuplicated}
          state={state}
          selectedCategory={state?.selectedCategory}
          handleEditRole={handleEditRole}
          archiveJobRole={archiveJobRole}
          unarchiveJobRole={unarchiveJobRole}
        />
      </HeaderFullWidth>
      {showEntendRolePopup && (
        <CloseRoleDrawer
          description={
            <>
              This application has already been edited once. You can now only
              modify the end date and time.
            </>
          }
          Textdescription={'All other fields will remain locked.'}
          Icon={ApprovedModelIcon}
          showDrawer={showEntendRolePopup}
          setShowDrawer={setShowEntendRolePopup}
          onCloseClick={handleCloseClick}
          onApprove={() => handleApproveClick(currentRole)}
          closeText={'Back'}
          YesText={'Edit'}
          closeButtonHeight={'38px'}
          closeButtonWidth={'80px'}
          yesButtonHeight={'38px'}
          yesButtonWidth={'105px'}
        />
      )}
    </SectionWrapper>
  )
}

export default JobRoles
